import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var BreakOpportunity = /** @class */ (function (_super) {
    __extends(BreakOpportunity, _super);
    function BreakOpportunity() {
        return _super.call(this) || this;
    }
    BreakOpportunity.forceNativeConstructor = true;
    BreakOpportunity.forceNativeMethods = true;
    BreakOpportunity.AUTO = 'auto';
    BreakOpportunity.ANY = 'any';
    BreakOpportunity.NONE = 'none';
    BreakOpportunity.ALL = 'all';
    return BreakOpportunity;
}(ASObject));
export { BreakOpportunity };
